import { NavLink, useSearchParams } from "react-router-dom";
import { Space, Tag, Alert as AntAlert } from "antd";
import { capitalize } from "../../utils/utils";
import { InfoCircleFilled } from "@ant-design/icons";

const STATUSES = {
  ENTREGADO: "green",
  ENTREGADO_PARCIAL: "warning",
  RECIBIDO: "blue",
  PROCESADO: "blue",
  INCONSISTENCIA: "orange",
  ERROR: "red",
  ERROR_ENVIO_SAP: "warning",
  ENVIADO_SAP: "default",
};

export const columns = [
  {
    title: "No. Orden",
    dataIndex: "ordenCompra",
    key: "ordenCompra",
  },
  {
    title: "# Entrega",
    dataIndex: "entrega",
    key: "entrega",
  },
  {
    title: "Cliente",
    dataIndex: "nombreCliente",
    key: "nombreCliente",
    render: (text) => text.replace('|', ' ').toUpperCase(),
  },
  {
    title: "Punto de Venta",
    dataIndex: "puntoVenta",
    key: "puntoVenta",
  },
  {
    title: "Cédula",
    dataIndex: "cedula",
    key: "cedula",
  },
  {
    title: "Fecha Pedido",
    dataIndex: "fechaPedido",
    key: "fechaPedido",
    //render: (text) => formatIntDate(text.toString())
  },
  {
    title: "Fecha Promesa",
    dataIndex: "fechaPromesa",
    key: "fechaPromesa",
    //render: (text) => formatIntDate(text.toString())
  },
  {
    title: "Fecha Entrega",
    dataIndex: "fechaEntrega",
    key: "fechaEntrega",
    //render: (text) => formatIntDate(text.toString())
  },
  {
    title: "Estado Orden",
    dataIndex: "estado",
    key: "estado",
    render: (_, record) => (
      <span>
        <Tag color={STATUSES[record.estado]}>
          {capitalize(record.estado.toUpperCase().replace(/_/g, " "))}
        </Tag>
        {record.alertaLogistica && (
          <InfoCircleFilled style={{ color: "#ff9900" }} />
        )}
      </span>
    ),
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    fixed: "right",
    width: 100,
    render: (_, record) => (
      <Space size="middle">
        <NavLink to={`/orders/${record.id}`}>
          Visualizar
        </NavLink>
      </Space>
    ),
  },
];

export const InconsistentMsg = ({count, onClick}) => {
  return (
    <AntAlert
      message={
        <>
          Existen <b>{count}</b> pedidos que presentan Incosistencia. Haz
          click en corregir para resolverlas.
        </>
      }
      type="error"
      showIcon
      onClick={onClick}
    />
  );
};

export const LogisticAlertMsg = ({count, onClick}) => {
  return (
    <AntAlert
      message={
        <>
          Existen <b>{count}</b> pedidos que presentan Incosistencia. Haz click
          en corregir para resolverlas.
        </>
      }
      type="warning"
      showIcon
      onClick={onClick}
    />
  );
};

export function useQueryParams (params) {
  const [searchParams, setSearchParams] = useSearchParams();
  setSearchParams({...searchParams, params})

}
